module.exports = __webpack_public_path__ + "static/img/banner1.4731f938.png";